/**
 * @desc 下架记录
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.lendMaster.shelvesRecord.Params, options?: any) {
  return updateResponse(
    http(URL + `/lendMaster/shelvesRecord`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
